import { StoreService } from './../../../services/store.service';
import { ClientsService } from './../../../services/reporting/clients.service';
import { AuthService } from 'src/app/services/auth.service';
import { AgentService } from './../../../services/agent.service';
import { ProfilService } from './../../../services/profil.service';
import { Router } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { Agent } from './../../../models/Agent';
import { Message, SelectItem, ConfirmationService } from 'primeng/primeng';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-modification-objectif',
  templateUrl: './modification-objectif.component.html',
  styleUrls: ['./modification-objectif.component.css']
})
export class ModificationObjectifComponent implements OnInit {
  colorFieldset = 'primary';
  colorPanel = 'primary';
  droit: boolean;
  titre = 'Gestion des Agents';
  msgs: Message[] = [];
  growlDefaultLife: number;
  items: Agent[] = [];
  items$: Observable<Agent[]>;
  item: any;
  editMode: boolean;
  displayDialog = false;
  itemId: any;
  totalElements: number;

  confirmation: string;
  listProfil: SelectItem[];
  listPoint: SelectItem[];
  listCategorie: SelectItem[];

  searchLibelle: string;
  searchPoint: string;
  searchProfil: string;

  displaychargement: boolean;
  formValid = false;
  form: FormGroup;



  profils: any[];
  objectifs: any[];
  allObjectifs: any[];
  disabled: true;

  fr = {
    firstDayOfWeek: 0,
    monthNames: [
      'Janvier', 'Février', 'Mars',
      'Avril', 'Mai', 'Juin',
      'Juillet', 'Août', 'Septembre',
      'Octobre', 'Novembre', 'Décembre'
    ],
    monthNamesShort: ['Janv.', 'Févr.', 'Mars', 'Avr.', 'Mai', 'Juin', 'Juil.', 'Août', 'Sept.', 'Oct.', 'Nov.', 'Déc.'],
    dayNames: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'],
    dayNamesShort: ['Dim.', 'Lun.', 'Mar.', 'Mer.', 'Jeu.', 'Ven.', 'Sam.'],
    dayNamesMin: ['D', 'L', 'M', 'M', 'J', 'V', 'S']
  };
  today: any = new Date();
  selectedPdg: string;
  selectedMsisdn: string;
  datedebut: any = new Date();
  datefin: any = new Date();

  selectedAnnee: any;
  selectedMois: any;
  listAnnee: SelectItem[] = [];
  listMois: SelectItem[] = [];
  listMsisdn: SelectItem[] = [];
  listLogin: SelectItem[] = [];
  constructor(private fb: FormBuilder,
    private router: Router,
    private profilService: ProfilService,
    private agentService: AgentService,
    private authService: AuthService,
    private clientsService: ClientsService,
    private store: StoreService,
    private confirmationService: ConfirmationService) {
  }

  async ngOnInit() {
    this.buildForm();
    this.getObjectifs();
    this.listMois = [];
    //this.listMois.push({ label: 'Mois...', value: null });
    this.listMois.push({ label: 'Janvier', value: "01" });
    this.listMois.push({ label: 'Février', value: "02" });
    this.listMois.push({ label: 'Mars', value: "03" });
    this.listMois.push({ label: 'Avril', value: "04" });
    this.listMois.push({ label: 'Mai', value: "05" });
    this.listMois.push({ label: 'Juin', value: "06" });
    this.listMois.push({ label: 'Juillet', value: "07" });
    this.listMois.push({ label: 'Aout', value: "08" });
    this.listMois.push({ label: 'Septembre', value: "09" });
    this.listMois.push({ label: 'Octobre', value: "10" });
    this.listMois.push({ label: 'Novembre', value: "11" });
    this.listMois.push({ label: 'Decembre', value: "12" });
    this.listAnnee = [];
    //this.listAnnee.push({ label: 'Année...', value: null });
    this.listAnnee.push({ label: '2020', value: "2020" });
    this.listAnnee.push({ label: '2021', value: "2021" });
    this.listAnnee.push({ label: '2022', value: "2022" });
    this.listAnnee.push({ label: '2023', value: "2023" });
    this.listAnnee.push({ label: '2024', value: "2024" });
    this.listAnnee.push({ label: '2025', value: "2025" });
    if (this.store.isUserPartenaire) {
      this.listLogin.push({ label: this.store.currentNomPDG, value: this.store.currentNomPDG });
      this.selectedPdg = this.store.currentNomPDG;
    } else {
      this.listLogin.push({ label: 'PDG...', value: null });
      try {
        let dataRetourPdg = <any>await this.clientsService.findAgents().toPromise();
        for (let el of dataRetourPdg) {
          this.listLogin.push({ label: el.login, value: el.login });
        }
      } catch (error) { }
    }
  }

  async onChangePDG(event) {
    this.listMsisdn = [];
    this.listMsisdn.push({ label: 'Msisdn...', value: null });
    let dataRet = <any>await this.clientsService.findByLogin(event).toPromise();
    for (let el of dataRet) {
      this.listMsisdn.push({ label: el.telephone, value: el.telephone });
    }
  }

  recherche() {
    console.log('selectedMois: ', this.selectedMois);
    console.log('selectedAnnee: ', this.selectedAnnee);
    console.log('selectedPdg: ', this.selectedPdg);
    console.log('selectedMsisdn: ', this.selectedMsisdn);
    this.objectifs = this.allObjectifs.filter(e => {
      return e.login_pdg === this.selectedPdg && e.annee_mois === this.selectedAnnee + '-' + this.selectedMois;
    });
  }

  selectElement(event) {
    this.editMode = true;
    this.item = this.cloneObject(event.data);
    this.displayDialog = true;
    this.router.navigate(['/agent-detail', this.item.login]);
  }

  editElement(data) {
    this.editMode = true;
    this.item = this.cloneObject(data),
      console.log('item: ', this.item);
    this.displayDialog = true;
    this.buildForm();
  }

  close() {
    this.item = null;
    this.displayDialog = false;
  }

  async getObjectifs() {
    this.allObjectifs = (await this.agentService.getObjectif().toPromise() as any);
    this.objectifs = this.allObjectifs;
    console.log('objectif: ', this.objectifs);
  }

  buildForm() {
    this.form = this.fb.group({
      id: [this.editMode && this.item && this.item.id || '', [Validators.required]],
      login_pdg: [this.editMode && this.item && this.item.login_pdg || '', [Validators.required]],
      msisdn_pdg: [this.editMode && this.item && this.item.msisdn_pdg || '', [Validators.required]],
      nom_zone: [this.editMode && this.item && this.item.nom_zone || '', [Validators.required]],
      produit: [this.editMode && this.item && this.item.produit || '', [Validators.required]],
      type_objectif: [this.editMode && this.item && this.item.type_objectif || '', [Validators.required]],
      annee_mois: [this.editMode && this.item && this.item.annee_mois || '', [Validators.required]],
      objectif: [this.editMode && this.item && this.item.objectif || '', [Validators.required]],
      date_affectation: [this.editMode && this.item && this.item.date_affectation || '', [Validators.required]],
    });
    console.log(';:::::::::', this.form.value);
  }

  async saveAgent() {
    this.displaychargement = true;
    console.log('fin');
    const dataToSend = {
      id: this.form.value.id,
      objectif: this.form.value.objectif
    };

    if (this.form.value.objectif === '') {
      this.msgs = [];
      this.msgs.push({ severity: 'error', summary: 'Erreur', detail: 'L\'objetif est vide !!!' });
      return;
    }
    console.log('dataToSend: ', dataToSend);
    try {
      const data = await this.agentService.modifyObjectif(dataToSend).toPromise();
      this.displayDialog = false;
      this.msgs = []; this.msgs.push({ severity: 'warning', summary: 'info', detail: 'Tratitement effectué avec succès' });
      this.item = new Agent();
      await this.getObjectifs();
    } catch (error) {
      console.error('Error:', error);
      this.msgs = []; this.msgs.push({ severity: 'warning', summary: 'info', detail: 'Tratitement échoué' });
    } finally {
      this.displaychargement = false;
    }
  }

  retour() {
    console.log('retour: ');
    this.displayDialog = false;
  }

  cloneObject(c: Agent): Agent {
    return Object.assign({}, c);
  }

}


